"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLOR_PANEL = void 0;
var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];
exports.COLOR_PANEL = COLOR_PANEL;


//////////////////
// WEBPACK FOOTER
// ./~/recharts/lib/util/Constants.js
// module id = 2446
// module chunks = 0